import logo from "@/assets/images/logo.png";
import logoWhite from "@/assets/images/logo-white.png";

export function Logo({ light = false, className = "" }) {
  return (
    <img
      src={light ? logoWhite : logo}
      alt="Mora Comigo"
      className={`h-10 w-auto object-contain ${className}`}
      data-testid="brand-logo"
    />
  );
}
